module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.90d1676.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-Medium.woff2
// module id = WeXI
// module chunks = 3